import { Fetch, Put } from "../../fetch";

/**
 * Saves coin fields on a webseries.
 *
 * ALL webseries calls on the coin/task pages go through /v4 (setu_v4) — the
 * staging/prod API domain is a gateway where UNPREFIXED paths route to the
 * OLD api service, whose WebSeries model silently DROPS the coin/watch-earn
 * fields. Locally both shapes hit setu, which hid this. Never remove /v4.
 *
 * PUT /webseries/{id} validates the full series model server-side, so we
 * cannot send only the coin fields. Following the ManageVseries edit path,
 * we prefill the full doc via GET /webseries/{id}?admin=true and merge the
 * coin fields on top before PUTting it back.
 */
export const putSeriesCoinFields = (
  apiUrl,
  token,
  seriesId,
  coinFields,
  callback,
  errCallback
) => {
  Fetch(`${apiUrl}/v4/webseries/${seriesId}?admin=${true}`, token, (result) => {
    if (!result || result.success === false) {
      errCallback();
      return;
    }
    // Strip response envelope / server-computed fields before PUTting back.
    const { success, _id, key, similar_webseries: similar, ...doc } = result;
    const payload = { ...doc, ...coinFields };
    Put(`${apiUrl}/v4/webseries/${seriesId}`, token, payload, callback, errCallback);
  });
};

/** Three-state price semantics (2026-07-14): blank -> null = "use global
 * default" (backend $unsets the field); explicit 0 = "DISABLED for this
 * series"; >0 = explicit price. */
export const normalizeCoinPrice = (value) =>
  value == null || value === "" ? null : Number(value);

/** Empty/blank validity falls back to the backend default (null). */
export const normalizeValidityDays = (value) =>
  value == null || value === "" ? null : Number(value);

/** Empty/blank bundle size falls back to the global default (null). */
export const normalizeBundleSize = (value) =>
  value == null || value === "" ? null : Number(value);
